import { render, staticRenderFns } from "./ShippingTime.vue?vue&type=template&id=6ba7a8e3&scoped=true&"
import script from "./ShippingTime.vue?vue&type=script&lang=js&"
export * from "./ShippingTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7a8e3",
  null
  
)

component.options.__file = "ShippingTime.vue"
export default component.exports